// src/components/WorkSection.jsx
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./WorkSection.css";

// Import images
import img1 from "../assets/pm-1.jpg";
import img2 from "../assets/AI-Powered Solutions.png";
import img3 from "../assets/story.jpg";
import img4 from "../assets/Scalable -Tech.jpg";

const projects = [
  { img: img1, name: "Seamless Digital Experiences." },
  { img: img2, name: "AI-Powered Solutions" },
  { img: img3, name: "Creative Brand Storytelling" },
  { img: img4, name: "Scalable Tech for Growth" },
];

const WorkSection = () => {
  return (
    <section className="work-section py-5">
      <Container fluid>
        {/* Heading */}
        <Row className="mb-4">
          <Col md={12} className="text-center">
            <p className="text-warning1 fw-bold mb-2">Our Work in Action</p>
            <h2 className="fw-bold display-5">
              Take a Look at <br /> What We’ve Built
            </h2>
          </Col>
        </Row>

        {/* Project Grid */}
        <Row>
          {projects.map((project, index) => (
            <Col md={3} xs={6} className="mb-3" key={index}>
              <div className="work-item">
                <img src={project.img} alt={project.name} className="img-fluid" />
                <div className="overlay">
                  <h5>{project.name}</h5>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default WorkSection;
